import React, { Fragment, Component, useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import { inject, observer } from 'mobx-react'
import Header from '../components/header/Header'
import Footer from './footer'
import MessageLogin from '../shared/alert/MessageLogin'
import User from '../models/UserStore'
import firebase from 'firebase/app'
import firebaseConfig from '../config/firebase'
import useProjectStore from '../hooks/store/useProjectStore'
import { useHistory } from 'react-router-dom'
import ProjectDialog from './projects/addProject'
import useAddProjectStore from '../hooks/store/useAddProjectStore'
import mixpanel from 'mixpanel-browser';
mixpanel.init("6005a050026c4fd4d872681c3aa77b8e");

firebase.initializeApp(firebaseConfig)
class App extends Component {
  state = {
    userId: User.getUid(),
    user: null
  }

  componentDidMount() {
    if (this.state.userId === 'null' || !this.state.userId) return
    User.getUserProfile(this.state.userId).then(({ data }) => {
      this.setState({user: data})
      mixpanel.identify(this.state.userId)

    })
  }
  render() {
    const {userId, user} = this.state
    return (
      <AppComponent
        userId={userId}
        modalStore={this.props.modalStore}
        user={user}
      >
        {this.props.children}
      </AppComponent>
    )
  }
}

export default inject('modalStore')(withRouter(observer(App)))

const AppComponent = (props) => {
  const history = useHistory()

  const { isOpenDialog, creating, onCloseDialog, onAddProject } = useAddProjectStore()
  const { getListProjects } = useProjectStore(props.userId)

  useEffect(() => {
    if (props.user) {
      const showTrialFinish = (props.user.days >= 7 || props.user.requests_number >= 30) && props.user.has_subscription === null;
      if (props.userId && !isClimate && !showTrialFinish) {
        getListProjects(props)
      }
    }
    
  }, [props.user])

  const handleAddProject = (projectName) => {
    // eslint-disable-next-line no-undef
    const userLang = navigator.language || navigator.userLanguage;
    // eslint-disable-next-line no-nested-ternary
    const lang = userLang.split('-')[0] === 'es' ? 'es' : userLang.split('-')[0] === 'pt' ? 'pt' : 'en';
    mixpanel.track('New folder')

    onAddProject({
      projectId: projectName,
      userId: props.userId,
      lang,
      callback:()=> props.modalStore.onCloseMenu(),
    });
  };

  const isClimate = history.location.pathname.includes('climate')

  return (
    <Fragment>
      <div>
        {props.modalStore.showMessageLogin && <MessageLogin />}
        <Header history={history} />
        <Fragment>{props.children}</Fragment>
      </div>
      {!props.userId && !isClimate && <Footer />}
      <ProjectDialog
        loading={creating}
        isOpen={isOpenDialog}
        onClose={onCloseDialog}
        onSubmit={handleAddProject}
      />
    </Fragment>
  )
}


// WEBPACK FOOTER //
// ./src/app/index.js